import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { LearnDeckContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";

import { LearnFlashcardActionButton } from "#learn-card-action-button";

/**
 * A quiz's action: Check until the learner has graded their selection, then Continue, which
 * commits the graded answer (`answer-quiz`) like a swipe either way does. A quiz is never rated.
 */
export function LearnFlashcardQuizControls() {
  // `null` while the quiz has not registered its controls yet.
  const [quizControls] = useContextSelectors(LearnDeckContext, (c) =>
    c.cardControls?.kind === "quiz" ? c.cardControls : null,
  );
  if (quizControls?.answer == null) {
    return (
      <LearnFlashcardActionButton
        // Nothing is committed by Check: it grades on the card, and Continue commits.
        action={{ correct: false, kind: "answer-quiz" }}
        disabled={quizControls === null || !quizControls.hasSelection}
        icon="LuCheck"
        label="Check"
        onPress={quizControls?.check}
        testID="quiz-card-check-button"
      />
    );
  }
  return (
    <LearnFlashcardActionButton
      action={{ correct: quizControls.answer.correct, kind: "answer-quiz" }}
      handlesAllActions
      label="Continue"
      swipeDirection="both"
      testID="quiz-card-continue-button"
    />
  );
}
